import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { TextBoxSC } from 'atoms/TextBox'
import { ButtonGroupWrapper } from 'blocks/ButtonGroup'
import { COLOR, MEDIA } from 'vars/index'
import { LayoutBlock } from '../LayoutBlock'

export const LayoutBlockAuthSC = styled(LayoutBlock)`
  a ${TextBoxSC} {
    text-underline-offset: 3px;

    &:active {
      color: var(${COLOR.ACCENT_PRIMARY_PRESSED});
    }
  }

  ${ButtonGroupWrapper} {
    ${ButtonSC} {
      width: 100%;
      ${MEDIA.MIN_600} {
        width: 240px;
        height: 48px;
      }
    }
  }
`
